export const buildReportData = (p) => {
    const { instance_id, module_type, tex_id } = p.texReportData;
    return {
        instance_id,
        module_type,
        tex_id,
        item_id: p.productId,
        item_type: p.productType
    };
};
